export default __webpack_public_path__ + "static/media/newLogo.be0856cf.svg";